import '../login/style.scss';


function ErrorPage(props: { message?: string }) {
    return (
        <div className='dbmar-page-wrapper'>
            <div className='dbmar-page'>
                <div className="card">
                    <div className="card-text-header">
                        <div className='text-center'>
                            <img src="/icons/dbmarlin-badge.svg" alt="DBmarlin" className="logo-large" width="200px"
                                 height="70px"/>
                        </div>
                        <p className='card-header'>An error has occurred</p>
                    </div>
                    <p className='card-text-message error'>{props.message ? props.message : ''}</p>
                    <p className='card-text-message'>If the error persists, then please contact DBmarlin support</p>
                </div>
            </div>
        </div>
    );
}


export default ErrorPage;
